module.exports = __webpack_public_path__ + "img/huan.56b91433.jpg";